<template>
  <div class="main-container">
    <Navbar></Navbar>
    <div class="main-content">
      <router-view />
    </div>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import Navbar from 'components/navbar.vue'
import PageFooter from 'components/page-footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    PageFooter,
  },
  data () {
    return {
      vipTypeMap: {
        1: '月',
        2: '季',
        3: '年'
      },
    }
  },
  computed: {
    token () {
      return this.$store.state.global.token
    },
    userInfo () {
      return this.$store.state.global.userInfo
    }
  },
  created() {
    if (this.token) {
      this.getUserInfo()
    }
  },
  mounted () {
    this.browserRedirect()
  },
  methods: {
    browserRedirect() {
      console.log('browserRedirect')
      const sUserAgent = navigator.userAgent.toLowerCase();
      if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
        window.location.href = 'http://soundx.cn/supervoice.html'
      } else {
        console.log('pc')
      }
    },
    async getUserInfo() {
      this.$store.dispatch('global/setUserInfo')
    }
  }
}
</script>

<style lang="scss">
.main-container {
  min-width: 1340px;
}
.main-content {
  min-width: 1340px;
  margin: 0 auto;
}
</style>
